export default "__VITE_ASSET__BSM7OvOh__"